import { LazyModule, LazyAction } from 'owa-bundling';
import type * as lazyIndex from './lazyIndex';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import('./lazyIndex'), {
    name: 'OwaBizChatShared',
});

export const lazyOpenBizChatSidePane: LazyAction<
    typeof lazyIndex.openBizChatSidePane,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openBizChatSidePane);

export const lazyOpenAgentChatAndAddPrompt: LazyAction<
    typeof lazyIndex.openAgentChatAndAddPrompt,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openAgentChatAndAddPrompt);

export const lazyConstructCopilotChatPromptFromText: LazyAction<
    typeof lazyIndex.constructCopilotChatPromptFromText,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.constructCopilotChatPromptFromText);

export const lazyGetAgentDetails: LazyAction<typeof lazyIndex.getAgentDetails, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getAgentDetails);

// Type-only export (no runtime cost, erased at compile time)
export type { AgentType } from './AgentType';

// NOTE: Non-lazy utilities have been removed from barrel exports to reduce bundle size.
// For createCanvasContextualChat, createCanvasQueryAnnotation:
//   import from 'owa-bizchat-shared/lib/utils/getCanvasContextualChat'
// For CALENDAR_AGENT_GPT_ID:
//   import from 'owa-bizchat-shared/lib/utils/agentConstants'
// For CMM IDs (CALENDAR_MEETING_HELP_ME_PREP_CMM_ID, etc.):
//   import from 'owa-bizchat-shared/lib/utils/ScenarioCMMIds'
